import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../core/services/api.service';
import { PageTitleService } from '../../../core/services/page-title.service';

@Component({
  selector: 'app-search-by-author',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-by-author.component.html',
  styleUrl: './search-by-author.component.scss',
})
export class SearchByAuthorComponent implements OnInit {
  view: 'search' | 'books' = 'search';

  searchInput = '';
  authorResults: any[] = [];
  isLoadingAuthors = false;
  hasSearched = false;
  searchError = '';

  selectedAuthor: any = null;
  authorBooks: any[] = [];
  isLoadingBooks = false;
  booksError = '';

  showCopiesModal = false;
  selectedBook: any = null;

  constructor(private api: ApiService, private pageTitle: PageTitleService) {}

  ngOnInit(): void {
    this.pageTitle.set('Search by Author', 'Find books by author name');
  }

  searchAuthors(): void {
    const term = this.searchInput.trim();
    this.hasSearched = true;
    this.searchError = '';
    this.authorResults = [];
    if (term.length < 2) {
      this.searchError = 'Enter at least 2 characters to search.';
      return;
    }
    this.isLoadingAuthors = true;
    this.api.getAuthors({ search: term }).subscribe({
      next: (data) => {
        this.authorResults = data || [];
        this.isLoadingAuthors = false;
        if (!this.authorResults.length) {
          this.searchError = 'No authors found matching your search.';
        }
      },
      error: (err: any) => {
        this.searchError = err?.message || 'Failed to load authors. Please try again.';
        this.isLoadingAuthors = false;
      },
    });
  }

  selectAuthor(author: any): void {
    this.selectedAuthor = author;
    this.authorBooks = [];
    this.booksError = '';
    this.isLoadingBooks = true;
    this.view = 'books';
    this.pageTitle.set('Search by Author', author.authorName);
    this.api.locateBooksByAuthor(author.authorName).subscribe({
      next: (books) => { this.authorBooks = books || []; this.isLoadingBooks = false; },
      error: (err: any) => { this.booksError = err?.message || 'Failed to load books.'; this.isLoadingBooks = false; },
    });
  }

  backToSearch(): void {
    this.view = 'search';
    this.selectedAuthor = null;
    this.pageTitle.set('Search by Author', 'Find books by author name');
  }

  viewCopies(book: any): void {
    this.selectedBook = book;
    this.showCopiesModal = true;
  }

  closeModal(): void {
    this.showCopiesModal = false;
    this.selectedBook = null;
  }

  statusLabel(status: string): string {
    if (status === 'C') return 'At Center';
    if (status === 'M') return 'Issued';
    if (status === 'S') return 'Scrapped';
    return status;
  }

  rowClass(status: string): string {
    if (status === 'C') return 'sba-row-center';
    if (status === 'M') return 'sba-row-issued';
    if (status === 'S') return 'sba-row-scrapped';
    return '';
  }
}
